import { ReactElement } from 'react';
import { JsonObject } from 'lib/json';
import SchemaOrg from './SchemaOrg';

interface JsonSchemaDataProps {
  jsonSchema?: JsonObject | Record<string, unknown> | null;
}

export default function JsonSchemaData({ jsonSchema }: JsonSchemaDataProps): ReactElement | null {
  if (!jsonSchema || typeof jsonSchema !== 'object' || Object.keys(jsonSchema).length === 0) {
    return null;
  }

  return <SchemaOrg json={jsonSchema as JsonObject} />;
}
